import { MemoryFragment } from './MemoryFragment.js';

export class Cpu {
    constructor(char, type = "random") {
        this.char = char; // "X" or "O"
        this.type = type; // "random" or "smart" or "new"

        // for smart mode
        this.cpuMemory = []; // array of MemoryFragments
        this.gameMovesIndexes = []; // array of MemoryFragment indexes in array above

        // Win/lose/tie log
        this.outcomes = [];
    }
    getMove (board) {
        switch (this.type) {
            case "random": return this.moveRandom(board);
            case "smart": return this.moveSmart(board);
            default: return this.moveRandom(board);
        }
    }


    moveRandom (board) {
        let move;
        while (board[move] !== "") {
            move = Math.ceil(Math.random() * 9);
        }
        return move;
    }


    moveSmart (board) {
        let transformation;
        let memoryFragment;
        let mfIndex;
        let move;
        for (let i = 0; i < this.cpuMemory.length; i ++) {
            if (transformation = this.cpuMemory[i].searchMemory(board)) {
                memoryFragment = this.cpuMemory[i];
                mfIndex = i;
                break;
            }
        }
        if (transformation == null) {
            mfIndex = this.cpuMemory.length;
            memoryFragment = new MemoryFragment(board)
            this.cpuMemory.push(memoryFragment);
            move = memoryFragment.getBestMove();
        } else {
            move = memoryFragment.getBestMove(); // Returns the number of a spot on the board
            move = transformation.transformBackMove(move);
        }

        this.gameMovesIndexes.push(mfIndex);

        if (board[move] !== "") {
            alert("Whoops: We have an overlap.");
            alert("Move position is " + move);
            alert("Transformation reflect is " + transformation.reflectH);
            alert("Transformation rotate is " + transformation.rotate);
        }

        return move;
    }
    giveGameResult(result, board) { // "X", "O", or "tie"
        this.outcomes.push(result == "tie" ? "tie" : (result == this.char ? "win" : "loss"));
        for (let i = 0; i < this.gameMovesIndexes.length; i ++) {
            if (result === this.char) { // CPU won
                // Gotta give a big pat on the back to each move
                this.cpuMemory[this.gameMovesIndexes[i]].addToScore(100 / (this.gameMovesIndexes.length - i)); // The farther away from the end, the less pats you get
            } else if (result === "tie") {
                this.cpuMemory[this.gameMovesIndexes[i]].divideScoreBy(2); // The farther away from the end, the less pats you get
            } else {
                this.cpuMemory[this.gameMovesIndexes[i]].addToScore(-100 / (this.gameMovesIndexes.length - i)); // The farther away from the end, the less pats you get
            }
        }
        this.gameMovesIndexes = [];
    }
    
    giveGameResultTraining(result, board) { // "X", "O", or "tie"
        this.outcomes.push(result == "tie" ? "tie" : (result == this.char ? "win" : "loss"));
        for (let i = 0; i < this.gameMovesIndexes.length; i ++) {
            if (result === this.char) { // CPU won
                // Gotta give a big pat on the back to each move
                this.cpuMemory[this.gameMovesIndexes[i]].addToScore(100 / (this.gameMovesIndexes.length - i)); // The farther away from the end, the less pats you get
            } else if (result === "tie") {
                this.cpuMemory[this.gameMovesIndexes[i]].addToScore(-30 / (this.gameMovesIndexes.length - i)); // The farther away from the end, the less pats you get
            } else {
                this.cpuMemory[this.gameMovesIndexes[i]].addToScore(-100 / (this.gameMovesIndexes.length - i)); // The farther away from the end, the less pats you get
            }
        }
        this.gameMovesIndexes = [];
    }
    getIntellimeter() {
        let intellimeter = 0;
        let wins = 0;
        let losses = 0;
        let ties = 0;
        let maxDataSize = 500;
        let numData = Math.min(maxDataSize, this.outcomes.length);
        for (let i = this.outcomes.length - numData; i < this.outcomes.length; i ++) {
            // loop through the latest 500 outcomes
            if (this.outcomes[i] == "win") wins ++;
            else if (this.outcomes[i] == "tie") ties ++;
            else if (i >= 0) losses ++;
        }
        intellimeter += Math.pow((ties + wins) / numData, 2);
        // intellimeter is a number between 0 and 1 at this point.
        // We need the exponent to be not less than 1. The more losses, the higher the exponent.
        let exponent = (losses / numData) + 1;//if (this.outcomes.length > 10000) alert(intellimeter);
        // intellimeter = Math.pow(intellimeter, exponent);//if (this.outcomes.length > 10000) {alert(exponent);alert(intellimeter);}
        return Math.max(Math.min(intellimeter * 100, 100), 0);
    }
}
